module.exports = __webpack_public_path__ + "static/media/editGreen.1be0960f.svg";